<template>
    <k-container class="my-8">
        <h3 class="font-bold text-2xl mb-4">{{ $t("verifyEmail") }}</h3>
        <div v-if="error">
            <p class="text-red-500">{{ $t("somethingHappened") }}</p>
            <div class="mt-3">
                <router-link to="/">{{ $t("pleaseClickToLogin") }}</router-link>
            </div>
        </div>
    </k-container>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                error: false,
                validation: {
                    fieldErrors: {}
                }
            }
        },
        async mounted() {
            this.verify();
        },
        methods: {
            async verify() {
                try {
                    const verificationToken = this.$route.params.token;
                    const resp = await this.$post('public/verify-email', {verificationToken: verificationToken});
                    this.$storeLogin(resp.token);
                    await this.$fetchInvestorProfile();
                    await this.$routeInvestor();
                    this.$trackGAEvent('registration', 'emailConfirm');
                    this.$trackGADataLayerEvent('email-verify-success', this.$root.$data.investorProfile.number)
                } catch (e) {
                    this.error = true;
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>

